import { CampaignsApi, CAMPAIGNS_MAX_LIMIT } from '../clients';
import { mapPromoCode } from '../mappers';

/**
 * Guard against a server whose `total` never reconciles with what it returns.
 * 20 pages of 100 is 2,000 campaigns — far past anything this page is built
 * for, and past where the client-side design in `promoCodes.js` should have
 * been replaced with server search anyway.
 */
const MAX_PAGES = 20;

/**
 * Every discount campaign, newest first, as promo-code rows.
 *
 * Walks the service's pages at its maximum page size and concatenates them:
 * the Promo Codes page searches and status-filters on facts the service cannot
 * filter by (see promoCodes.js), so it needs the whole set. Stops when a page
 * comes back short or the echoed `total` is reached, whichever first — the
 * service echoes `limit` after clamping, so the loop follows what it actually
 * got rather than what it asked for.
 */
export const getPromoCodes = async () => {
  const rows = [];
  const now = Date.now();

  for (let page = 1; page <= MAX_PAGES; page += 1) {
    // Sequential on purpose: each page's `total` decides whether there is a next.
    // eslint-disable-next-line no-await-in-loop
    const data = await CampaignsApi.getCampaigns({
      page,
      limit: CAMPAIGNS_MAX_LIMIT,
      mechanismType: 'discount',
    });
    const campaigns = Array.isArray(data?.campaigns) ? data.campaigns : [];

    rows.push(...campaigns.map((campaign) => mapPromoCode(campaign, now)));

    const limit = Number(data?.limit) || CAMPAIGNS_MAX_LIMIT;
    const total = Number(data?.total);
    const reachedTotal = Number.isFinite(total) && rows.length >= total;

    if (campaigns.length < limit || reachedTotal) break;
  }

  return rows;
};
